var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

import PropTypes from 'prop-types';
/**
 * 基本组件的通用 Props 定义
 */

export var basicPropTypes = {
  // 自定义 class
  className: PropTypes.string,
  // 自定义样式
  style: PropTypes.object,
  // 与该组件绑定的实体对象
  entity: PropTypes.object
};
/**
 * 表单输入基本组件的通用 Props 定义
 */

export var controlPropTypes = {
  // 输入组件的 name，作为该输入组件在其所属表单内的唯一识别符
  name: PropTypes.string.isRequired,
  // 初始值，具体类型需各个组件自行定义
  value: PropTypes.oneOfType([PropTypes.bool, PropTypes.number, PropTypes.string, PropTypes.arrayOf(PropTypes.bool), PropTypes.arrayOf(PropTypes.number), PropTypes.arrayOf(PropTypes.string)]),
  // 占位符
  placeholder: PropTypes.string,
  // 该输入组件是否为禁用状态，默认值为 false
  disabled: PropTypes.bool,
  // change 事件，处理器函数接收如下两个参数：
  //
  // - {any} newValue - 改变后的值
  // - {string} name - 该组件的 name
  onChange: PropTypes.func
};
/**
 * 从父组件继承通用props
 *
 * @param props 子组件 props
 * @param parentProps 父组件 props
 */

export function extendsParentProps(props, parentProps) {
  var entity = parentProps.entity,
      entities = parentProps.entities,
      routes = parentProps.routes,
      history = parentProps.history,
      location = parentProps.location,
      match = parentProps.match,
      staticContext = parentProps.staticContext,
      params = parentProps.params;
  return __assign({
    entity: entity,
    entities: entities,
    routes: routes,
    history: history,
    location: location,
    match: match,
    staticContext: staticContext,
    params: params
  }, props);
}